/* Tiptoe storefront behaviour. No dependencies. */
(() => {
  const T = window.Tiptoe || {};
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- money ---------- */
  function formatMoney(cents, format = T.moneyFormat || '${{amount}}') {
    const value = Number(cents) / 100;
    const withDelims = (n, dec, thou = ',', decSep = '.') => {
      const [i, d] = n.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (d ? decSep + d : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0);
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        default: return withDelims(value, 2);
      }
    });
  }
  const escapeHtml = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- cart api ---------- */
  const routes = T.routes || { cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cart: '/cart.js' };
  async function api(url, body) {
    const res = await fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
    return data;
  }
  const getCart = () => api(routes.cart);
  const addItems = (items) => api(routes.cartAdd, { items });
  const changeLine = (line, quantity) => api(routes.cartChange, { line, quantity });

  /* ---------- drawer ---------- */
  const drawer = $('[data-drawer]');
  const panel = drawer && $('[data-drawer-panel]', drawer);
  let lastFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('drawer-lock');
    document.body.classList.add('drawer-open');
    setTimeout(() => ($('.drawer__close', drawer) || panel).focus(), 60);
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('drawer-lock');
    document.body.classList.remove('drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (drawer) {
    drawer.addEventListener('click', (e) => { if (e.target.closest('[data-close-cart]')) closeDrawer(); });
    document.addEventListener('keydown', (e) => {
      if (!drawer.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeDrawer();
      if (e.key === 'Tab') {
        const f = $$('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])', panel).filter((el) => el.offsetParent !== null);
        if (!f.length) return;
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }
  $$('[data-open-cart]').forEach((el) => el.addEventListener('click', async (e) => {
    if (!drawer) return;
    e.preventDefault();
    openDrawer();
    try { renderCart(await getCart()); } catch (err) { /* keep last render */ }
  }));

  function productJson() {
    const el = $('[data-product-json]');
    try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
  }
  const PRODUCT = productJson();
  const pairSaving = (PRODUCT && PRODUCT.pairSaving) || T.pairSaving || 0;

  function sized(url, w) { return url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : ''; }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count || ''; el.dataset.count = cart.item_count; });
    if (!drawer) return;
    const body = $('[data-drawer-body]', drawer);
    const foot = $('[data-drawer-foot]', drawer);
    if (!cart.item_count) {
      body.innerHTML = '<div class="drawer__empty"><p>Your cart is empty.</p><button type="button" class="more" data-close-cart>Keep looking</button></div>';
      foot.hidden = true;
      return;
    }
    const art = $('[data-line-art]');
    const artHtml = art ? art.innerHTML : '';
    let bandQty = 0;
    let upsellVariant = null;
    const lines = cart.items.map((item, i) => {
      if (!PRODUCT || item.product_id === PRODUCT.id) { bandQty += item.quantity; upsellVariant = upsellVariant || item.variant_id; }
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<div class="line__variant">${escapeHtml(item.variant_title)}</div>` : '';
      const allocs = (item.line_level_discount_allocations || []).filter((a) => a.amount > 0);
      const disc = allocs.map((a) => `<div class="line__discount">${escapeHtml(a.discount_application.title)} (−${formatMoney(a.amount)})</div>`).join('');
      const price = item.final_line_price < item.original_line_price
        ? `${formatMoney(item.final_line_price)}<s>${formatMoney(item.original_line_price)}</s>`
        : formatMoney(item.final_line_price);
      const isBand = PRODUCT ? item.product_id === PRODUCT.id : !!artHtml;
      const img = isBand || !item.image ? artHtml : `<img src="${sized(item.image, 180)}" alt="" loading="lazy" width="72" height="72">`;
      return `<div class="line">
        <div class="line__img">${img}</div>
        <div>
          <div class="line__title">${escapeHtml(item.product_title)}</div>${variant}${disc}
          <div class="qty" role="group" aria-label="Quantity for ${escapeHtml(item.product_title)}">
            <button type="button" data-line="${i + 1}" data-qty="${item.quantity - 1}" aria-label="Remove one">${iconMinus}</button>
            <span>${item.quantity}</span>
            <button type="button" data-line="${i + 1}" data-qty="${item.quantity + 1}" aria-label="Add one">${iconPlus}</button>
          </div>
        </div>
        <div class="line__price">${price}</div>
      </div>`;
    }).join('');
    let upsell = '';
    if (bandQty === 1 && upsellVariant && pairSaving > 0) {
      upsell = `<div class="upsell"><div><b>Add a second band</b><span>One for your partner, or a gift. Saves ${formatMoney(pairSaving)}.</span></div>
        <button type="button" class="btn" data-upsell="${upsellVariant}">Add</button></div>`;
    }
    body.innerHTML = lines + upsell;
    const saving = cart.total_discount || 0;
    $('[data-totals]', drawer).innerHTML = `
      <div><span>Subtotal</span><span>${formatMoney(cart.original_total_price)}</span></div>
      ${saving > 0 ? `<div class="is-saving"><span>Bundle saving</span><span>−${formatMoney(saving)}</span></div>` : ''}
      <div><span>Delivery</span><span>Free</span></div>
      <div class="is-total"><span>Total</span><span>${formatMoney(cart.total_price)}</span></div>`;
    foot.hidden = false;
  }
  const iconMinus = '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 12h12"/></svg>';
  const iconPlus = '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M12 6v12M6 12h12"/></svg>';

  if (drawer) {
    drawer.addEventListener('click', async (e) => {
      const q = e.target.closest('[data-line]');
      const up = e.target.closest('[data-upsell]');
      try {
        if (q) { q.disabled = true; renderCart(await changeLine(Number(q.dataset.line), Math.max(0, Number(q.dataset.qty)))); }
        if (up) { up.classList.add('is-loading'); await addItems([{ id: Number(up.dataset.upsell), quantity: 1 }]); renderCart(await getCart()); }
      } catch (err) {
        renderCart(await getCart().catch(() => ({ item_count: 0, items: [] })));
      }
    });
  }

  /* ---------- buy form ---------- */
  const form = $('[data-buy-form]');
  if (form && PRODUCT) {
    const variants = new Map(PRODUCT.variants.map((v) => [String(v.id), v]));
    const fallbackId = $('[data-fallback-id]', form);
    const fallbackQty = $('[data-fallback-qty]', form);
    const atc = $('[data-atc]', form);
    const status = $('[data-buy-status]', form);
    const row2 = $('[data-colour-row="2"]', form);
    const slot1Label = $('[data-slot-1-label]', form);

    const chosen = (slot) => {
      const input = $(`input[name="colour-${slot}"]:checked`, form);
      return input ? input.value : fallbackId.value;
    };
    const bundle = () => Number(($('input[name="bundle"]:checked', form) || { value: 1 }).value);

    function update() {
      const b = bundle();
      const v1 = variants.get(chosen(1));
      const v2 = variants.get(chosen(2)) || v1;
      if (row2) row2.hidden = b !== 2;
      if (slot1Label) slot1Label.textContent = b === 2 ? 'Band 1' : 'Colour';
      [1, 2].forEach((slot) => {
        const input = $(`input[name="colour-${slot}"]:checked`, form);
        const label = $(`[data-colour-name="${slot}"]`, form);
        if (input && label) label.textContent = input.dataset.colour;
      });
      const total = b === 2 ? v1.price + v2.price - pairSaving : v1.price;
      $$('[data-price], [data-atc-price], [data-sticky-price]').forEach((el) => { el.textContent = formatMoney(total); });
      fallbackId.value = v1.id;
      fallbackQty.value = b;
      const available = v1.available && (b === 1 || v2.available);
      atc.disabled = !available;
    }
    form.addEventListener('change', update);
    update();

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const b = bundle();
      const id1 = Number(chosen(1));
      const id2 = Number(chosen(2)) || id1;
      const items = b === 2 ? (id1 === id2 ? [{ id: id1, quantity: 2 }] : [{ id: id1, quantity: 1 }, { id: id2, quantity: 1 }]) : [{ id: id1, quantity: 1 }];
      atc.classList.add('is-loading');
      atc.setAttribute('aria-busy', 'true');
      try {
        await addItems(items);
        const cart = await getCart();
        renderCart(cart);
        status.textContent = 'Added to cart';
        pulse(atc);
        openDrawer();
      } catch (err) {
        status.textContent = err.message;
        showError(form, err.message);
      } finally {
        atc.classList.remove('is-loading');
        atc.removeAttribute('aria-busy');
      }
    });
  }

  function showError(root, message) {
    let el = $('.notice--err', root);
    if (!el) { el = document.createElement('p'); el.className = 'notice notice--err'; el.setAttribute('role', 'alert'); root.appendChild(el); }
    el.textContent = message;
    setTimeout(() => el.remove(), 6000);
  }

  /* quick add (final call to action) */
  $$('[data-quick-add]').forEach((btn) => btn.addEventListener('click', async () => {
    btn.classList.add('is-loading');
    try {
      await addItems([{ id: Number(btn.dataset.quickAdd), quantity: 1 }]);
      renderCart(await getCart());
      pulse(btn);
      openDrawer();
    } catch (err) {
      showError(btn.parentElement, err.message);
    } finally {
      btn.classList.remove('is-loading');
    }
  }));

  /* ---------- sticky buy bar ---------- */
  const sticky = $('[data-sticky-buy]');
  const mainAtc = form && $('[data-atc]', form);
  if (sticky && mainAtc && 'IntersectionObserver' in window) {
    let atcVisible = true;
    let finalVisible = false;
    const sync = () => {
      const show = !atcVisible && !finalVisible;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
      const btn = $('[data-sticky-atc]', sticky);
      if (btn) btn.tabIndex = show ? 0 : -1;
    };
    new IntersectionObserver(([entry]) => { atcVisible = entry.isIntersecting; sync(); }).observe(mainAtc);
    const final = $('.final');
    if (final) new IntersectionObserver(([entry]) => { finalVisible = entry.isIntersecting; sync(); }, { threshold: 0.25 }).observe(final);
    $('[data-sticky-atc]', sticky).addEventListener('click', () => {
      if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
  }

  /* ---------- gallery ---------- */
  $$('[data-gallery]').forEach((gallery) => {
    const track = $('[data-gallery-track]', gallery);
    const slides = $$('[data-slide]', gallery);
    const thumbs = $$('[data-thumb]', gallery);
    const dotsWrap = $('[data-gallery-dots]', gallery);
    if (slides.length < 2) { if (dotsWrap) dotsWrap.remove(); $('[data-gallery-thumbs]', gallery)?.remove(); return; }
    const dots = slides.map((_, i) => {
      const d = document.createElement('button');
      d.type = 'button'; d.className = 'gallery__dot'; d.tabIndex = -1;
      d.addEventListener('click', () => go(i));
      dotsWrap.appendChild(d);
      return d;
    });
    const go = (i) => track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
    thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    const mark = () => {
      const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      dots.forEach((d, k) => d.setAttribute('aria-current', String(k === i)));
      thumbs.forEach((t, k) => t.setAttribute('aria-current', String(k === i)));
    };
    track.addEventListener('scroll', () => requestAnimationFrame(mark), { passive: true });
    mark();
  });

  /* ---------- the tremor ----------
     The only motion on the site. [data-tremor] loops while on screen;
     [data-tremor-once] plays one set of pulses when triggered. */
  function pulse(el) {
    if (reduceMotion || !el) return;
    el.classList.remove('is-added');
    void el.offsetWidth;
    el.classList.add('is-added');
    setTimeout(() => el.classList.remove('is-added'), 600);
  }
  function tremorOnce(el) {
    if (reduceMotion || !el) return;
    el.classList.add('is-live');
    clearTimeout(el._tt);
    el._tt = setTimeout(() => el.classList.remove('is-live'), 1250);
  }
  if (!reduceMotion && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => e.target.classList.toggle('is-live', e.isIntersecting));
    }, { threshold: 0.15 });
    $$('[data-tremor]').forEach((el) => io.observe(el));
  }

  /* ---------- 5:29 → 5:30 ---------- */
  const setSeg = (svg, text) => {
    const digits = $$('.seg__d', svg);
    const chars = text.replace(':', '').split('');
    digits.forEach((d, i) => { d.dataset.d = chars[i] === ' ' || chars[i] === undefined ? '_' : chars[i]; });
  };
  $$('[data-night]').forEach((night) => {
    const clock = $('[data-clock] .seg', night);
    const plan = $('[data-tremor-once]', night);
    if (!clock || reduceMotion || !('IntersectionObserver' in window)) return;
    setSeg(clock, '5:29');
    let done = false;
    new IntersectionObserver(([entry], obs) => {
      if (!entry.isIntersecting || done) return;
      done = true;
      obs.disconnect();
      setTimeout(() => { setSeg(clock, '5:30'); tremorOnce(plan); }, 900);
    }, { threshold: 0.6 }).observe(clock);
    if (plan) new IntersectionObserver(([entry]) => { if (entry.isIntersecting && done) tremorOnce(plan); }, { threshold: 0.5 }).observe(plan);
  });

  /* ---------- footer clock: the real time, right now ---------- */
  const footClock = $('[data-footer-clock]');
  if (footClock) {
    const seg = $('.seg', footClock);
    const ampm = $('[data-footer-ampm]', footClock);
    const said = $('[data-footer-time]', footClock);
    const tick = () => {
      const now = new Date();
      let h = now.getHours();
      const m = String(now.getMinutes()).padStart(2, '0');
      const pm = h >= 12;
      h = h % 12 || 12;
      setSeg(seg, String(h).padStart(2, ' ') + ':' + m);
      seg.setAttribute('viewBox', h < 10 ? '74 0 234 100' : '0 0 308 100');
      ampm.textContent = pm ? 'pm' : 'am';
      if (said) said.textContent = `${h}:${m} ${pm ? 'pm' : 'am'}`;
    };
    tick();
    footClock.hidden = false;
    setInterval(tick, 20000);
  }

  /* ---------- delivery estimate ---------- */
  const deliveryEl = $('[data-delivery]');
  if (deliveryEl && window.Intl) {
    const addBusinessDays = (date, n) => {
      const d = new Date(date);
      let added = 0;
      while (added < n) { d.setDate(d.getDate() + 1); const day = d.getDay(); if (day !== 0 && day !== 6) added += 1; }
      return d;
    };
    const fmt = new Intl.DateTimeFormat('en-AU', { weekday: 'short', day: 'numeric', month: 'short' });
    const now = new Date();
    const from = addBusinessDays(now, Number(T.deliveryMin) || 6);
    const to = addBusinessDays(now, Number(T.deliveryMax) || 10);
    deliveryEl.innerHTML = `Order today and it should arrive between <b>${fmt.format(from)}</b> and <b>${fmt.format(to)}</b>. Free tracked delivery.`;
  }
})();
